import { ApiResponse } from './api';

export type NotesType = 'request' | 'event' | 'action' | 'other';

export enum NotesTypes {
  request = 'Request',
  event = 'Event',
  action = 'Action',
  other = 'Other',
}
export type UserNotes = {
  id: number;
  content: string;
  userId: number;
  creator: string;
  type: NotesType | string;
  createdAt: Date | string;
  updatedAt: Date | string;
};

export type FetchUserNoteResponse = ApiResponse<UserNotes>;
export type FetchUserNotesResponse = ApiResponse<{
  items: UserNotes[];
  totalItems: number;
}>;

export type CreateUserNoteRequest = Omit<UserNotes, 'id' | 'creator' | 'createdAt' | 'updatedAt'>;
export type CreateUserNoteResponse = ApiResponse<UserNotes>;

export type UpdateUserNoteRequest = Omit<UserNotes, 'creator' | 'createdAt' | 'updatedAt'>;
export type UpdateUserNoteResponse = ApiResponse<UserNotes>;
